module.exports = { ANONYMOUS: 0, FREE: 1, PREMIUM: 2 };



// WEBPACK FOOTER //
// ./src/constants/musica/users-type.jsx